import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { MatRippleModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { TimeFrameSelectionsComponent } from './time-frame-selections.component';
import { YearAndQuartalSelectionModule } from '../year-and-quartal-selection/year-and-quartal-selection.module';
import { MonthSelectionModule } from '../month-selection/month-selection.module';
import { WeekSelectionModule } from '../week-selection/week-selection.module';
import { DateRangeSelectionModule } from '../date-range-selection/date-range-selection.module';
import { MatListModule } from '@angular/material/list';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatButtonToggleModule } from '@angular/material/button-toggle';

@NgModule({
  declarations: [TimeFrameSelectionsComponent],
  imports: [
    CommonModule,
    IonicModule,
    MatTableModule,
    TranslateModule.forChild({}),
    MatRippleModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatIconModule,
    FormsModule,
    MatDatepickerModule,
    ReactiveFormsModule,
    YearAndQuartalSelectionModule,
    MonthSelectionModule,
    WeekSelectionModule,
    DateRangeSelectionModule,
    MatListModule,
    MatCheckboxModule,
    MatButtonToggleModule,
  ],
  exports: [TimeFrameSelectionsComponent],
  providers: [],
})
export class TimeFrameSelectionsModule {}
